// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3Lr3Z{position:relative}._3Lr3Z ._2lwl0{position:absolute;bottom:0;left:0;width:100%}._3Lr3Z .c__Dp._3kBgE{right:0}.mPKSm{width:100%;height:auto}.mPKSm._2zVrz{opacity:0 !important;transition:opacity 350ms}\n", ""]);
// Exports
exports.locals = {
	"carousel": "_3Lr3Z",
	"dots": "_2lwl0",
	"arrows": "c__Dp",
	"arrow__next": "_3kBgE",
	"bannerImg": "mPKSm",
	"hidden": "_2zVrz"
};
module.exports = exports;
